import type {
  ConfigurationType,
  ExistingSystemType,
  LevelType,
  SystemOptionType
} from 'data/types';
import {
  isDuctedCompatibilitySystem,
  resolveDuctedLayoutConfiguration
} from 'utils/ducted-quote-layout';

export type ResolveSystemFloorplanConfigurationParams = {
  system: SystemOptionType;
  configurations: ConfigurationType[];
  existingSystems: ExistingSystemType[];
  structure: LevelType[];
};

export function resolveSystemFloorplanConfiguration({
  system,
  configurations,
  existingSystems,
  structure
}: ResolveSystemFloorplanConfigurationParams): ConfigurationType | null {
  if (isDuctedCompatibilitySystem(system)) {
    return resolveDuctedLayoutConfiguration({
      system,
      existingSystems,
      structure,
      configurations
    });
  }
  return (
    configurations.find(
      (configuration) =>
        configuration.uniqueId === system.configuration.uniqueId
    ) ?? null
  );
}
